import { render, staticRenderFns } from "./SetDangerEquipment.vue?vue&type=template&id=8b53335c&scoped=true"
import script from "./SetDangerEquipment.vue?vue&type=script&lang=js"
export * from "./SetDangerEquipment.vue?vue&type=script&lang=js"
import style0 from "./SetDangerEquipment.vue?vue&type=style&index=0&id=8b53335c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b53335c",
  null
  
)

export default component.exports